<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7" class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            <!-- {{$route.name}} -->
          </h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav> -->
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>

      
    </base-header>

    <b-container fluid class="mt--6" style="margin-top:-38px !important">
     
      <b-row class="justify-content-center" >
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI-股市问诊</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI智能分析股市走势，多维度解析当下行情趋势；仅作技术研究，不构成任何投资建议。
                <br/>如输入：请帮忙分析中国平安后续走势！ 请帮忙分析建设银行和招商银行！ <br/>
                
            </p>            
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form class="needs-validation" @submit.prevent="handleSubmit(formSubmit)">
            <p style="margin-top:30px;margin-bottom:30px">
                <base-input
                    name="股票代码"
                    placeholder="今天想问点什么？"
                    prepend-icon="ni ni-money-coins"
                    type="text"
                    v-model="content"
                >
                </base-input>
                <base-button v-if="!thinking" type="primary" native-type="submit">向AI提问</base-button>
                <base-button v-if="thinking" type="neutral" >思考中 ...</base-button>
            </p>       
            </form>
            </validation-observer>     
          </card>

          <card  v-if="chatContents.length > 0">
            <h2 slot="header" class="mb-0">AI解析</h2>
            <div class="detail-content">
               <section  class="send-box">
                    <div  v-for="row in chatContents" class="question-and-answer">
                        <div v-if="row.type == 'diagnosis' && row.question_answer == 'question'" class="question-box">
                            <p  class="question-text">{{row.content}}</p>
                        </div>
                        <div v-if="row.type == 'diagnosis' && row.question_answer == 'answer'" class="answer-box">
                            <div class="answer-text">
                                <p class="p-text">{{row.content}}</p>
                            </div>
                        </div>
                    </div>
              </section>
            </div>
          </card>


      </b-col>
    </b-row>



  </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import BaseHeader from '@/components/BaseHeader';
import aiApi from "../../api/ai";

import { Table, TableColumn, Select, Option } from "element-ui";

export default {
    name: 'grid-system',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        BaseHeader,
        RouteBreadcrumb
    },
    data() {
        return {
            content:"",
            chatContents:[],
            thinking:false
            
        };
    },
   
    methods: {
    
      
        async formSubmit() {
            if(this.content == "" || this.content.trim() == "")
            {
                return;
            }
            this.thinking = true;
            const param = {
                type : "diagnosis",
                content:this.content
            }

            console.log("this.content",this.content,param)

            const res = await aiApi.sent(param);

            if (res && res.code == 200) {
                const row = {
                    content : this.content, 
                    question_answer:"question",
                    type:"diagnosis",
                }

                this.chatContents.unshift(row);

                this.content = "";
            }
        },
        async getList()
        {
            this.thinking = false;

            let fromData = {type:"diagnosis"}
            const res = await aiApi.chatlist(fromData);
            if (res && res.code == 200) {
                const { data } = res;
                this.chatContents = data.list;
                console.log("this.chatContents:",this.chatContents)
            }
        },
    },
    
    mounted() {
        this.getList();
        this.timer = setInterval(this.getList, 3000);
    },

    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style>

.fee-nav-list {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #bfbfbf;
    padding: 5px 50px 0px;
}
.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item {
    height: 48px;
    box-sizing: content-box;
    padding: 0 25px;
    color: #9d9d9d;
    font-weight: 700;
    font-size: 26px;
    cursor: pointer;
}

.fee-module-body-card {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;

}

.fee-card-pc {
    background-color: #eeeeee;
    box-shadow: 0 23px 27px 0 rgba(215,221,229,.2);
    border-radius: 16px 20px 20px 20px;
    padding-top: 26px;
    width: 140px;
    height: 118px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-left: 14px;

}



.fee-card-pc .fee-card-body-long {
    color: #ff6900;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc .fee-card-body-short {
    color: #41ce09;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc .fee-card-body-none {
    color: #8d8d8d;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}


.fee-card-pc .fee-card-body-title-big {
    font-size: 22px;
}
.fee-card-pc .fee-card-body-title {
    text-align: center;
    font-weight: 300;
    margin-top: 5px;
}


.detail-r{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.detail-content {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    overflow: hidden;
}

.detail-content .send-box {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    -ms-scroll-chaining: none;
    overscroll-behavior: none;
    margin: auto 0 0.26vw;
    -webkit-overflow-scrolling: touch;
}

.detail-content .send-box .question-box {
    margin: 1.563vw 0;
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}

.detail-content .send-box .question-text {
    margin-bottom: 0.781vw;
    padding: 0.677vw 1.042vw;
    /* max-width: 28.646vw; */
    background: rgba(110, 40, 248, .7);
    font-size: 16px;
    font-family: Roboto-Regular, Roboto-Bold, Roboto, PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 1.146vw;
    border-radius: 1.25vw 1.25vw 0 1.25vw;
    overflow: hidden;
    text-align: left;
    pointer-events: all;
}
.detail-content .send-box .answer-box {
    margin: 10px 0;
    padding: 1.563vw 1.823vw 1.823vw;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 1.25vw;
    overflow: hidden;
    background: -webkit-gradient(linear, left top, right top, color-stop(0, #e8e8e8), to(#e8e8e8));
    background: -o-linear-gradient(left, #e8e8e8 0, #e8e8e8);
    background: linear-gradient(90deg, #e8e8e8 0, #e8e8e8);
    border-radius: 1.042vw;
}

.detail-content .send-box .answer-img.answer-text, .detail-content .send-box  .answer-text.answer-text, .detail-content .send-box .question-text.answer-text {
    background: #252627;
    border-radius: 1.25vw 1.25vw 1.25vw 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.detail-content .send-box  .answer-img,  .detail-content .send-box .answer-text, .detail-content .send-box .question-text {
    margin-bottom: 15px;
    padding: 15px 20px;
    max-width: 800px;
    background: #5e72e4;
    font-size: 16px;
    font-family: Roboto-Regular, Roboto-Bold, Roboto, PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    border-radius: 1.25vw 1.25vw 0 1.25vw;
    overflow: hidden;
    text-align: left;
    pointer-events: all;
}
</style>
